import { Link } from '@solidjs/router';
import { Show, useContext } from 'solid-js';
import { AppContext } from '../../../../app-context-provider/app-context-provider';
import { NewAtosCareLogo } from '../../../icons-library/new-atos-care-logo';
import { NewAtosLogoDeepBlue } from '../../../icons-library/new-atos-logo-deep-blue';
import { CrossIcon } from '../../../icons-library/cross';
import { ArrowLeftIcon } from '../../../icons-library/arrow-left';
import type { MenuHeaderMobileProps, MenuHeaderProps } from '../../menu-types';

export const MenuHeader = (props: MenuHeaderProps & MenuHeaderMobileProps) => {
    const { siteInfo, localize } = useContext(AppContext);

    const isDrilledIn = () => Boolean(props.activeParent?.());

    return (
        <div class="flex items-center justify-between gap-cvi-2 py-cvi-5">
            <Show
                when={isDrilledIn()}
                fallback={
                    <Link
                        href="/"
                        class="block shrink-0 w-cvi-logo-sm-w h-cvi-logo-sm-h"
                        onClick={() => props.handleCloseMenuClick()}
                        ref={(el: HTMLElement) => props.firstElement?.(el)}
                    >
                        <Show when={siteInfo.siteType === 'default'} fallback={<NewAtosCareLogo width={8} height={4.34} />}>
                            <NewAtosLogoDeepBlue width="100%" height="100%" />
                        </Show>
                    </Link>
                }
            >
                <button
                    class="icon-button-secondary-neutral icon-button-secondary-neutral-md"
                    onClick={() => props.onBack?.()}
                    aria-label={localize('back-to-menu', 'Back to menu')}
                    ref={(el: HTMLButtonElement) => props.firstElement?.(el)}
                >
                    <ArrowLeftIcon fill="currentColor" size="medium" />
                </button>
            </Show>
            <button
                class="icon-button-ghost icon-button-ghost-md"
                onClick={() => props.handleCloseMenuClick()}
                aria-label={localize('close-menu', 'Close menu')}
            >
                <CrossIcon fill="currentColor" size="medium" />
            </button>
        </div>
    );
};
